import {
  BiHealth,
  FaRegHospital,
  GiOrganigram,
  MdOutlineMedicalServices,
  VscOrganization,
} from 'react-icons/all';

const routesConfig = [
  {
    id: 'health',
    title: 'Health',
    messageId: 'sidebar.health',
    type: 'group',
    authorities: [],
    children: [
      {
        id: 'patient',
        title: 'Patient',
        messageId: 'sidebar.health.info',
        type: 'item',
        icon: <BiHealth />,
        path: '/health/patient',
        authorities: [],
      },
      {
        id: 'requests',
        title: 'Requests',
        messageId: 'sidebar.health.requests',
        type: 'item',
        icon: <MdOutlineMedicalServices />,
        path: '/health/requests',
        authorities: [],
      },
      {
        id: 'organizations',
        title: 'Organizations',
        messageId: 'sidebar.health.organizations',
        type: 'item',
        icon: <GiOrganigram />,
        path: '/health/organizations',
      },
      {
        id: 'locations',
        title: 'Locations',
        messageId: 'sidebar.health.locations',
        type: 'item',
        icon: <FaRegHospital />,
        path: '/health/locations',
      },
      {
        id: 'practitioners',
        title: 'Practitioners',
        messageId: 'sidebar.health.practitioners',
        type: 'item',
        icon: <VscOrganization />,
        path: '/health/practitioners',
      },
    ],
  },
];
export default routesConfig;
